import React from "react";
import {
  Grid,
  Typography,
  Card,
  CardContent,
  CardMedia,
  Box,
} from "@mui/material";

import leaders from "../../../../assets/leaders.jpg";
import c1 from "../../../../assets/c1.png";
import c2 from "../../../../assets/c2.jpg";
import c3 from "../../../../assets/c3.png";
import c4 from "../../../../assets/c4.jpg";
import hands from "../../../../assets/image.png";
import indoor from "../../../../assets/indoorgames.png";
import yoga from "../../../../assets/yoga.png";
import Drawing from "../../../../assets/image2.jpg";
import birthday from "../../../../assets/birthday.png";
import Greeting from "../../../../assets/Greeting.png";
import Footer from "../componets/Footer";
import Header from "../componets/Header";
import NewsHeader from "../componets/NewsHeader";

const activities = [
  {
    title: "Sand play",
    image: c1,
  },
  {
    title: "Outdoor play",
    image: indoor,
  },
  {
    title: "Puzzles",
    image: c3,
  },
  {
    title: "Parachute play",
    image: c4,
  },
  {
    title: "Yoga",
    image: yoga,
  },
];
const socialactivities = [
  {
    title: "Birthday celebration ritual",
    image: birthday,
  },
  {
    title: "Greeting time",
    image: Greeting,
  },
  {
    title: "Rhyme Time",
    image: c3,
  },
  {
    title: "Story Time",
    image: c4,
  },
];
const literacyactivities = [
  {
    title: "Readers Make Leaders",
    image: leaders,
  },
  {
    title: "Glenn Doman Reading",
    image: c2,
  },
];
const numeracyactivities = [
  {
    title: "Block Play",
    image: c1,
  },
  {
    title: "Hands on activities",
    image: hands,
  },
  {
    title: "Number Fun in the Outdoors",
    image: c3,
  },
];
const creativeactivities = [
  {
    title: "Drawing",
    image: Drawing,
  },
  {
    title: "Dance",
    image: c3,
  },
  {
    title: "Puppet Show",
    image: c2,
  },
];

const UniqueActivities = () => {
  return (
    <>
      <NewsHeader />
      <Header />
      <Box
        sx={{
          width: "80%",
          mx: "auto",
          textAlign: "center",
          justifyContent: "center",
          alignItems: "center",
          mt: 10,
        }}
      >
        <Typography>
          The early childhood programs at Podar Prep are designed to give
          children the correct stress-free environment, personal attention and
          scientifically formulated schedule of activities to nurture their
          growing brains. Appropriate socio-emotional care is given to each
          child to help him develop the right interpersonal and intrapersonal
          Intelligence
        </Typography>
      </Box>
      <Box sx={{ py: 6, px: { xs: 3, md: 0 }, backgroundColor: "#fff" }}>
        <Typography
          sx={{
            color: "#005ca8",
            fontFamily: "-moz-initial",
            textAlign: "center",
            fontWeight: "bold",
            fontSize: { xs: 20, md: 35 },
            mb: 4,
          }}
        >
          Motor Skills Development
        </Typography>

        <Grid container spacing={2} justifyContent="center">
          {activities.map((activity, index) => (
            <Grid item xs={12} sm={6} md={2.2} key={index}>
              <Card
                sx={{
                  borderRadius: 3,
                  boxShadow: 3,
                  transition: "transform 0.3s",
                  "&:hover": {
                    transform: "scale(1.03)",
                  },
                }}
              >
                <CardMedia
                  component="img"
                  height="150"
                  image={activity.image}
                  alt={activity.title}
                  sx={{ objectFit: "cover" }}
                />
                <CardContent
                  sx={{
                    textAlign: "center",
                    backgroundColor: "#f5f5f5",
                    height: 25,
                    width: "80%",
                    mx: "auto",
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: "bold",
                      color: "#336699",
                      fontFamily: "cursive",
                      fontSize: 15,
                    }}
                  >
                    {activity.title}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
      <Box sx={{ py: 6, px: 3, backgroundColor: "#fff" }}>
        <Typography
          sx={{
            mb: 4,
            color: "#005ca8",
            fontFamily: "-moz-initial",
            textAlign: "center",
            fontWeight: "bold",
            fontSize: { xs: 20, md: 35 },
          }}
        >
          SOCIAL AND EMOTIONAL DEVELOPMENT
        </Typography>

        <Grid container spacing={4} justifyContent="center">
          {socialactivities.map((activity, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Card
                sx={{
                  borderRadius: 3,
                  boxShadow: 3,
                  transition: "transform 0.3s",
                  "&:hover": {
                    transform: "scale(1.03)",
                  },
                }}
              >
                <CardMedia
                  component="img"
                  height="200"
                  image={activity.image}
                  alt={activity.title}
                  sx={{ objectFit: "cover" }}
                />
                <CardContent
                  sx={{
                    textAlign: "center",
                    backgroundColor: "#f5f5f5",
                    height: 30,
                    width: "80%",
                    mx: "auto",
                  }}
                >
                  <Typography
                    variant="subtitle1"
                    sx={{
                      fontWeight: "bold",
                      fontSize: "1rem",
                      color: "#336699",
                      fontFamily: "cursive",
                    }}
                  >
                    {activity.title}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
      <Box sx={{ py: 6, px: 3, backgroundColor: "#fff" }}>
        <Typography
          sx={{
            mb: 4,
            color: "#005ca8",
            fontFamily: "-moz-initial",
            textAlign: "center",
            fontWeight: "bold",
            fontSize: { xs: 20, md: 35 },
          }}
        >
          Language and Literacy
        </Typography>

        <Grid container spacing={4} justifyContent="center">
          {literacyactivities.map((activity, index) => (
            <Grid item xs={12} sm={6} md={6} key={index}>
              <Card
                sx={{
                  borderRadius: 3,
                  boxShadow: 3,
                }}
              >
                <CardMedia
                  component="img"
                  height="350"
                  image={activity.image}
                  alt={activity.title}
                  sx={{ objectFit: "cover" }}
                />
                <CardContent
                  sx={{
                    textAlign: "center",
                    backgroundColor: "#f5f5f5",
                    height: 30,
                    width: "80%",
                    mx: "auto",
                  }}
                >
                  <Typography
                    variant="subtitle1"
                    sx={{
                      fontWeight: "bold",
                      fontSize: "1rem",
                      color: "#336699",
                      fontFamily: "cursive",
                    }}
                  >
                    {activity.title}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
      <Box sx={{ py: 6, px: 3, backgroundColor: "#fff" }}>
        <Typography
          sx={{
            mb: 4,
            color: "#005ca8",
            fontFamily: "-moz-initial",
            textAlign: "center",
            fontWeight: "bold",
            fontSize: { xs: 20, md: 35 },
          }}
        >
          NUMERACY
        </Typography>

        <Grid container spacing={4} justifyContent="center">
          {numeracyactivities.map((activity, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                sx={{
                  borderRadius: 3,
                  boxShadow: 3,
                }}
              >
                <CardMedia
                  component="img"
                  height="300"
                  image={activity.image}
                  alt={activity.title}
                  sx={{ objectFit: "cover" }}
                />
                <CardContent
                  sx={{
                    textAlign: "center",
                    backgroundColor: "#f5f5f5",
                    height: 30,
                    width: "80%",
                    mx: "auto",
                  }}
                >
                  <Typography
                    variant="subtitle1"
                    sx={{
                      fontWeight: "bold",
                      fontSize: "1rem",
                      color: "#336699",
                      fontFamily: "cursive",
                    }}
                  >
                    {activity.title}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
      <Box sx={{ py: 6, px: 3, backgroundColor: "#fff" }}>
        <Typography
          sx={{
            mb: 4,
            color: "#005ca8",
            fontFamily: "-moz-initial",
            textAlign: "center",
            fontWeight: "bold",
            fontSize: { xs: 20, md: 35 },
          }}
        >
          Creative and Aesthetic Expression
        </Typography>

        <Grid container spacing={4} justifyContent="center">
          {creativeactivities.map((activity, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                sx={{
                  borderRadius: 3,
                  boxShadow: 3,
                }}
              >
                <CardMedia
                  component="img"
                  height="300"
                  image={activity.image}
                  alt={activity.title}
                  sx={{ objectFit: "cover" }}
                />
                <CardContent
                  sx={{
                    textAlign: "center",
                    backgroundColor: "#f5f5f5",
                    height: 30,
                    width: "80%",
                    mx: "auto",
                  }}
                >
                  <Typography
                    variant="subtitle1"
                    sx={{
                      fontWeight: "bold",
                      fontSize: "1rem",
                      color: "#336699",
                      fontFamily: "cursive",
                    }}
                  >
                    {activity.title}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Box>
      <Footer />
    </>
  );
};

export default UniqueActivities;

